import * as React from "react";
import {
  Text,
  View,
  Dimensions,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import Colors from "../../utilities/Color.js";
import { dismissNotification } from "../../redux/actions/NotificationActions";
import Moment from "moment";
import { Shadow } from "react-native-shadow-2";
import FooterBarWide from "../../components/footerBarWide";
import { Ionicons } from "@expo/vector-icons";


export default function NotificationListScreen() {
  const notificationList = useSelector(
    (state) => state.notifications.notificationsList
  );
  const [notifRefresh, setNotifRefresh] = React.useState(0);

  function dismissNotif(notifid) {
    setNotifRefresh(notifRefresh + 1);
    dismissNotification(notifid);
  }

  const win = Dimensions.get("window");
  // const [modalVisible, setModalVisible] = useState(false);
  const navigation = useNavigation();
  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollView}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="" />
            <View style={GlobalStyles.headerContainerKLYellow}>
              <View style={GlobalStyles.headerTextYellow}>
                <Text style={GlobalStyles.headingStyle}>Notifications</Text>
                <Text style={GlobalStyles.subheaderStyleWeb}>
                </Text>
              </View>
            </View>
          </View>
        ) : (
          <View>
            <View style={styles.headerContainer}>
              <StatusBar data="BM" />
              <View style={[GlobalStyles.headerContainerKL, { height: 70 }]}>
                <View style={GlobalStyles.headerText}>
                  <Text style={GlobalStyles.headingStyle}>Notifications</Text>
                </View>
              </View>
            </View>
          </View>
        )
        }
        <View style={GlobalStyles.containerNmax}>
          <View style={styles.bodyContainerFull}>
            {notificationList.filter(notif => !notif.dismissed).map((notif, index) => {
              return (
                <View key={"notification".concat(index)}>
                  <View style={styles.listPaddingContainer}>
                    <Shadow
                      distance={5}
                      startColor={Colors.LIGHTGRAY}
                      endColor={Colors.WHITE}
                      offset={[0, 0]}
                      style={styles.shadowcorners}
                    >
                      <View style={styles.boxContainer}>
                        <View style={styles.headerBar}>
                          <View style={styles.headerBarA}></View>
                          <View style={styles.headerBarB}>
                            <Text style={styles.dateText}>{Moment(notif.dateText).format("D MMMM, YYYY")}</Text>
                          </View>
                          <View style={styles.headerBarC}>
                            {/* <TouchableOpacity
                            onPress={() => dismissNotif(notif.notificationId)}
                            style={{
                              alignItems: "flex-end",
                              justifyContent: "center",
                              marginBottom: 20,
                              height: 20,
                              paddingLeft: 5,
                            }}
                          >
                            <Ionicons
                              name="md-close-outline"
                              size={20}
                            />
                          </TouchableOpacity> */}
                          </View>
                        </View>
                        <View>
                          <View>
                            <Text style={styles.headerText}>{notif.title}</Text>
                          </View>
                          <View>
                            <Text style={styles.bodyStyle}>{notif.description}</Text>

                            {notif.navigationTo === undefined ? <></> :
                              <TouchableOpacity
                                style={styles.GoButtonStyle}
                                activeOpacity={0.5}
                                onPress={() => navigation.navigate(notif.navigationTo)}
                              >
                                <Text
                                  style={[
                                    styles.textButtonStyle,
                                    { color: "black" },
                                  ]}
                                >
                                  {notif.linkText}
                                </Text>
                              </TouchableOpacity>
                            }
                          </View>
                        </View>
                      </View>
                    </Shadow>
                  </View>
                </View>
              );
            })}
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  backgroundContainerBlue: {
    flex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  closeBottom: {
    color: "red",
  },
  headerBar: {
    flexDirection: "row",
  },
  headerBarA: {
    flex: 1,
  },
  headerBarB: {
    flex: 6,
  },
  headerBarC: {
    flex: 1,
    marginBottom: 50,
  },
  headerText: {
    fontFamily: "montserrat-bold",
    fontSize: 16,
    textAlign: "center",
    marginBottom: 15,
  },
  dateText: {
    fontFamily: "montserrat-medium",
    fontSize: 8,
    textAlign: "center",
    color: "#2E7B9C"
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    marginBottom: 15,
  },
  bodyLink: {
    fontFamily: "montserrat-bold",
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5,
  },
  bodyContainerFull: {
    paddingTop: 10,
    paddingLeft: 25,
    paddingRight: 25,
  },
  boxContainer: {
    backgroundColor: "#ffffff",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 25,
    paddingRight: 25,
  },
  GoButtonStyle: {
    borderRadius: 50,
    backgroundColor: Colors.YELLOW,
    height: 50,
    justifyContent: 'center',
    alignSelf: "center",
    height: 52,
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
  textButtonStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
  listPaddingContainer: {
    marginTop: 10,
    marginBottom: 10,
    marginRight: 10,
    marginLeft: 10,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
  },
  scrollView: {
    backgroundColor: "#ffffff"
  }
});
